import { render, staticRenderFns } from "./FilterInspectionType.vue?vue&type=template&id=4bfc38a8&scoped=true&"
import script from "./FilterInspectionType.vue?vue&type=script&lang=ts&"
export * from "./FilterInspectionType.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bfc38a8",
  null
  
)

export default component.exports